export default __webpack_public_path__ + "static/media/61.b2590ce2.png";